<div class="dunning-action-modal" [class.block-loader]="loader.isLoading$ | async">
	<loader-spinner [model]="loader" loadingMessage="Dunning.SendingCostsCheck.Loading"/>

	<div class="modal-header">
		<h2 class="modal-title" translate="Dunning.SendingCostsCheck.Title"></h2>
	</div>

	<div class="modal-body">
		@if (balance$ | async; as balance) {
			@if (balance.isMonthlyMaxAmountReached) {
				<p translate="Dunning.SendingCostsCheck.BodyKO"></p>
			}
			@else {
				<p translate="Dunning.SendingCostsCheck.BodyOK" [translateParams]="{ remainingBalance: balance.remainingBalance }"></p>
			}
		}
	</div>

	<div class="dunning-action-modal-actions form-actions">
		<button type="button"
				(click)="onClose()"
				class="btn btn-default"
				translate="Actions.Close" data-cy="Close"></button>
		<button [disabled]="(canSubmit$ | async) === false"
				(click)="onSubmit()"
				class="btn btn-primary"
				translate="Actions.Achieve" data-cy="Achieve"></button>
	</div>
</div>
